import { Component, EventEmitter, OnDestroy, Output, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-custom-snackbar',
  standalone: true,
  imports: [
    MatButtonModule,
    MatIconModule,
  ],
  templateUrl: './custom-snackbar.component.html',
  styleUrl: './custom-snackbar.component.scss',
})
export class CustomSnackbarComponent implements OnDestroy {

  @Output() allMessagesCleared = new EventEmitter<void>();

  messages = signal<any[]>([]);
  closeLabel: string = 'Close';
  maximumMessageDisplayed: number = 1;

  ngOnDestroy(): void {}

  addMessage(msg: string, closeLabel: string, duration: number = 5000) {
    this.closeLabel = closeLabel;
    const message = { msg, timestamp: new Date().getTime() };

    if (this.messages().length >= this.maximumMessageDisplayed) {
      this.messages.update(current => [
        ...current.map((m, i) => i === 0 ? { ...m, leaving: true } : m)
      ]);
      setTimeout(() => {
        this.messages.update(current => [...current.slice(1), message]);
      }, 150);
    } else {
      this.messages.update(current => [...current, message]);
    }
  }

  onClose(index: number) {
    const message = this.messages()[index];
    if (!message) return;
    this.messages.update(current =>
      current.map((m, i) => i === index ? { ...m, leaving: true } : m)
    );
    setTimeout(() => {
      this.messages.update(current => current.filter((_, i) => i !== index));
      if (this.messages().length === 0) this.allMessagesCleared.emit();
    }, 200);
  }

  closeAllSnackbar() {
    this.messages.update(current => current.map(m => ({ ...m, leaving: true })));
    setTimeout(() => {
      this.messages.set([]);
      this.allMessagesCleared.emit();
    }, 3000); // special case for paacap patient we need to retain messages longer.
    // these that the cases where a popup is shown on each navigation
  }
}
